<div class="container" style="margin-top: 110px; text-align: center; padding: 40px 20px;">
  <div class="not-found-content">
    <img alt="page not found" ngSrc="../../../../assets/img/404.webp" width="300" height="200">
    <h1 style="margin-top: 30px; font-weight: 700; color: #0e8667;">{{ 'Page_not_found' | translate }}</h1>
    <p style="margin: 20px 0; color: #717171;">{{ 'Sorry_the_page_you_are_looking_for_does_not_exist' | translate }}</p>
    <button (click)="goToHome()" mat-button 
      style="border-radius: 8px; box-shadow: 0 0 50px rgba(48, 164, 135, 0.35); 
      background: linear-gradient(90deg, #A5C296 0%, #1DAB87 21.87%, #1DAB87 47.92%, #0092CC 100%); 
      font-weight: 700; color: white; padding: 10px 30px; margin-top: 20px;">
      {{ 'Back_to_home' | translate }}
    </button>
  </div>
</div>